import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "@apollo/client";
//import { LOGIN, FIND_USER } from "../queries";
import { Button, TextField } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
//import { Link } from "@mui/material";
//import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ACTIVATE_USER, GET_USERPASSCODE } from "../queries";
import { useParams } from "react-router-dom";
//import bcrypt from "bcryptjs";
//const bcryptjs = require("bcryptjs");
//import { useParams } from "react-router-dom";
// Material Kit 2 React examples
//import DefaultFooter from "examples/Footers/DefaultFooter";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
//import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/strategia.jpg";
//import { set } from "lodash";
//import kunnat from "kunnat";
/* eslint-disable react/prop-types */
const UserActivation = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  const [ok, setOk] = useState(true);
  const [code, setCode] = useState("");
  // eslint-disable-next-line
  const [email, setEmail] =useState("");
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  // eslint-disable-next-line
  const [token, setToken] = useState("");
  let coderead = useParams().id;
  useEffect(() => {
    ////console.log(coderead);
    if (coderead !== undefined) {
      setCode(coderead);
    }
  }, []);
  function onChange(value) {
    //console.log("Captcha value:", value);
    setToken(value);
    setVerified(!verified);
  }
  /*const decryptCode = useQuery(DECRYPT_CODE, {
    variables: { code },
  });
  */
  const getCode = useQuery(GET_USERPASSCODE, {
    variables: { email },
  });
  const [activateUser] = useMutation(ACTIVATE_USER, {
    onError: (error) => {
      setOk(false);
      //console.log(error);
      //setError(error.graphQLErrors[0].message);
      setError(error);
    },
    //setOk("ok");
  });
  //useEffect(() => {
  const submit = async () => {
    if (code.length > 5 && email.length > 3) {
      //const emaili = await decryptCode;
      //await setEmail(emaili.data.decryptCode.message);
      ////console.log(emaili.data.decryptCode.message);
      let co = await getCode;
      //console.log(co.data.getUserpasscode);
      if (co.data !== undefined) {
        if (co.data.getUserpasscode.message === code) {
          await activateUser({
            variables: { email: email, activated: true },
          });
          setSubmitted(true);
        } else {
          setError("Virhe tiedoissa");
        }
      }
    }
    //}, [code, activateUser]);
  };
  if (ok && !submitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {t("headers.useractivation")}
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <div style={{ width: "100%", display: "flex", placeContent: "center" }}>
          {t("common.email")}:
          <br />
          <TextField value={email} onChange={({ target }) => setEmail(target.value)} />
        </div>
        <div style={{ width: "100%", display: "flex", placeContent: "center" }}>
          {t("common.code")}:
          <br />
          <TextField value={code} onChange={({ target }) => setCode(target.value)} />
        </div>
        <br />
        <br />
        <div style={{ width: "100%", display: "flex", placeContent: "center" }}>
          <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
        </div>
        <br />
        <br />
        <div style={{ width: "100%", textAlign: "center" }}>
          <br />
          <Button
            variant="contained"
            style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
            type="submit"
            disabled={!verified}
            onClick={submit}
          >
            {submitted ? t("common.done") : executing ? "Verifying" : t("common.activate")}
          </Button>
          <br />
          <br />
          <a href="/">{t("common.tostart")}</a>
        </div>
      </>
    );
  }
  if (!ok) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.useractivation")}</h2>
                <br />
                {t("common.activationfailed")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.useractivation")}</h2>
                <br />
                {t("common.activationok")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};
export default UserActivation;
